import client from 'data/client';
import { CDError } from 'utils/error';

export type Variables = {
  orderId: string;
};

export type ResponseStatus = {
  status: string;
};

export const markReadyOrder = async ({ orderId }: Variables) => {
  try {
    const { data } = await client.post<ResponseStatus>(
      `/orders/${orderId}/mark_ready`,
    );
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.response.data);
  }
};

export const markCompleteOrder = async ({ orderId }: Variables) => {
  try {
    const { data } = await client.post<ResponseStatus>(
      `/orders/${orderId}/mark_complete`,
    );
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.response.data);
  }
};

export const printOrderAction = async ({ orderId }: Variables) => {
  try {
    const { data } = await client.post<ResponseStatus>(
      `/orders/${orderId}/print`,
    );
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.response.data);
  }
};
